import { connect } from 'react-redux';
import { Instances } from '../../../../constants';
import { IStateType } from '../../../../store/models/root.interface';
import { makeSelectObject, requestObject } from '../../../../store/Object';
import { closeSideBar, getParams } from '../../../../store/sidebar';
import SenderIdEditForm, { DispatchPropsType, SenderIdPropType } from '../organisms/senderId/senderIdEditForm';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { requestObjects } from '../../../../store/Objects';
import { getvSMSEnableRoutes } from '../../../../store/actions/smsSenderId.action';

const mapStateToProps = (state: IStateType) => {
    const selectData = state.senderId.senderIdDataById;
    const info = state.senderId
    return (state: IStateType) => ({
        data: selectData || {},
        params: getParams(state),
        info: info,
        userProfile: state.profile
    });
}

const mapDispatchToProps = {
    onLoad: () => requestObjects(Instances.smsSenderId),
    onClose: () => closeSideBar(),
    onSave: (id: any, formData: any, successCallback: (res: any, flag: boolean) => void) => requestObject(Instances.smsSenderIdEdit, undefined, undefined, 'PUT', true, true, formData, (response: any, flag: boolean) => successCallback(response, flag), id),
    uploadDocument: (document: any) => requestObject(Instances.smsSenderIdDocument, undefined, undefined, 'post', true, true, document),
    onLoadRoutes: (callback: (data: any, flag: boolean) => void) => getvSMSEnableRoutes(callback),
};

export default connect<SenderIdPropType, DispatchPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(withImmutablePropsToJS(SenderIdEditForm));